import { Segment, getCountry } from '@fxtr/i18n';

/** `FIXTER-UK` uses `/postcodes/.../addresses`; other segments use Google Places. */
export function shouldUseUkPostcodeLookup(segment) {
  return segment === Segment.Fixter_UK;
}

export function getAddressCountry(address = {}, segment) {
  if (address.country) return address.country;
  if (address.countryISOCode) return address.countryISOCode;
  if (address.countryPostalName) return address.countryPostalName;

  return getCountry(segment);
}

export function prepareAddressForSave(address = {}, segment) {
  const country = getAddressCountry(address, segment);
  return { ...address, country: country.toUpperCase() };
}
